module.exports = __webpack_public_path__ + "static/media/cardtadasana.1a364d86.jpg";